import React from 'react';
import { Box, Grid } from '@mui/material';

import { Container } from '@/components/layout';

import Icon from '@/components/icons/Icon';
import xw from 'xwind';
import {
  HowWorksItemDesc,
  HowWorksItemTitle,
  HowWorksItemTitleText,
  HowWorksWrapper,
} from './HowWorksList.styles';

export type THowItem = {
  title: string;
  description: string;
  iconName: string;
};

const HowWorksList: React.FC<{ list: any }> = ({ list }) => {
  return (
    <HowWorksWrapper>
      <Container>
        <Grid
          container
          spacing={{ lg: 12.5, xs: 22 }}
          alignItems="stretch"
          justifyContent={{ xs: 'center', lg: 'flex-start' }}
        >
          {list.map((item, index) => (
            <Grid
              key={item.title}
              item
              container
              xs={12}
              lg={4}
              style={xw`text-center max-w-md lg:max-w-none relative`}
            >
              <HowWorksItemTitle
                sx={{ pt: '34px' }}
                need_arrow={index !== list.length - 1 ? 1 : 0}
              >
                <Box sx={{ position: 'absolute', top: '20px' }}>
                  {item.icon}
                </Box>
                <HowWorksItemTitleText>{item.title}</HowWorksItemTitleText>
                <HowWorksItemDesc>{item.description}</HowWorksItemDesc>
              </HowWorksItemTitle>
            </Grid>
          ))}
        </Grid>
      </Container>
    </HowWorksWrapper>
  );
};

export default HowWorksList;
